export default __webpack_public_path__ + "static/media/ReadMore.83f47467.svg";